exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html,body,.close-account-status-container-1SwcvZdemwr{min-height:100vh}body{margin:0;display:flex;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Helvetica,Ubuntu,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";flex-direction:column}#app{flex:1}.close-account-status-container-1SwcvZdemwr{display:flex;flex-direction:column;justify-content:center;text-align:center;background-color:#006fc8;color:#ffffff}.close-account-status-content-5iahfFYgmwr{padding:0 40px}.close-account-status-title-1sS8KAZymwr{-webkit-animation-name:close-account-status-fadeIn-3WhO3wWCmwr;animation-name:close-account-status-fadeIn-3WhO3wWCmwr;-webkit-animation-duration:400ms;animation-duration:400ms;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-iteration-count:1;animation-iteration-count:1}@-webkit-keyframes close-account-status-fadeIn-3WhO3wWCmwr{0%{opacity:0}100%{opacity:1}}@keyframes close-account-status-fadeIn-3WhO3wWCmwr{0%{opacity:0}100%{opacity:1}}.close-account-status-logo-20xC6WDLmwr{position:absolute;top:40px;left:40px}.close-account-status-copyright-1tHBBJNzmwr{position:absolute;left:40px;bottom:40px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"container": "close-account-status-container-1SwcvZdemwr",
	"content": "close-account-status-content-5iahfFYgmwr",
	"title": "close-account-status-title-1sS8KAZymwr",
	"fadeIn": "close-account-status-fadeIn-3WhO3wWCmwr",
	"logo": "close-account-status-logo-20xC6WDLmwr",
	"copyright": "close-account-status-copyright-1tHBBJNzmwr"
};